import React from 'react';

const ClockIcon = () => (
  <svg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.5 0.0917969C2.49855 0.0917969 0.0917969 2.52551 0.0917969 5.5C0.0917969 8.47449 2.49855 10.9082 5.5 10.9082C8.50145 10.9082 10.9082 8.47449 10.9082 5.5C10.9082 2.52551 8.47449 0.0917969 5.5 0.0917969ZM5.5 9.82656C3.12044 9.82656 1.17344 7.87953 1.17344 5.5C1.17344 3.12047 3.12044 1.17344 5.5 1.17344C7.87956 1.17344 9.82656 3.12044 9.82656 5.5C9.82656 7.87956 7.87956 9.82656 5.5 9.82656Z'
      fill='white'
    />
    <path
      d='M5.7704 2.7959H4.95917V6.04082L7.79848 7.74435L8.2041 7.06833L5.7704 5.63518V2.7959Z'
      fill='white'
    />
  </svg>
);

export default ClockIcon;
